'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_SYNOPSES_REQUEST: 'FETCH_SYNOPSES_REQUEST',
    FETCH_SYNOPSES_SUCCEEDED: 'FETCH_SYNOPSES_SUCCEEDED',
    FETCH_SYNOPSES_FAILED: 'FETCH_SYNOPSES_FAILED',
    FETCH_SYNOPSIS_REQUEST: 'FETCH_SYNOPSIS_REQUEST',
    FETCH_SYNOPSIS_SUCCEEDED: 'FETCH_SYNOPSIS_SUCCEEDED',
    FETCH_SYNOPSIS_FAILED: 'FETCH_SYNOPSIS_FAILED',
    EDIT_SYNOPSIS_REQUEST: 'EDIT_SYNOPSIS_REQUEST',
    EDIT_SYNOPSIS_SUCCEEDED: 'EDIT_SYNOPSIS_SUCCEEDED',
    EDIT_SYNOPSIS_FAILED: 'EDIT_SYNOPSIS_FAILED',
    EDIT_SYNOPSIS_CANCELED: 'EDIT_SYNOPSIS_CANCELED',
    CHANGE_FILTER: 'CHANGE_FILTER',
    APPLY_FILTER_ERROR: 'APPLY_FILTER_ERROR',
    CLEAR_SYNOPSES_FILTER: 'CLEAR_SYNOPSES_FILTER'
};

function fetchSynopsesRequest(filter) {
    return {
        type: actionTypes.FETCH_SYNOPSES_REQUEST,
        filter: filter
    };
}

function fetchSynopsesSucceeded(synopses, filter) {
    return {
        type: actionTypes.FETCH_SYNOPSES_SUCCEEDED,
        synopses: synopses,
        filter: filter
    };
}

function fetchSynopsesFailed(message) {
    return {
        type: actionTypes.FETCH_SYNOPSES_FAILED,
        message: message
    };
}

function fetchSynopsisRequest(synopsisId) {
    return {
        type: actionTypes.FETCH_SYNOPSIS_REQUEST,
        synopsisId: synopsisId
    };
}

function fetchSynopsisSucceeded(synopsis) {
    return {
        type: actionTypes.FETCH_SYNOPSIS_SUCCEEDED,
        synopsis: synopsis
    };
}

function fetchSynopsisFailed() {
    return {
        type: actionTypes.FETCH_SYNOPSIS_FAILED
    };
}

function editSynopsisRequest(synopsisId, synopsis, redirect) {
    return {
        type: actionTypes.EDIT_SYNOPSIS_REQUEST,
        synopsisId: synopsisId,
        synopsis: synopsis,
        redirect: redirect
    };
}

function editSynopsisSucceeded() {
    return {
        type: actionTypes.EDIT_SYNOPSIS_SUCCEEDED
    };
}

function editSynopsisFailed() {
    return {
        type: actionTypes.EDIT_SYNOPSIS_FAILED
    };
}

function editSynopsisCanceled() {
    return {
        type: actionTypes.EDIT_SYNOPSIS_CANCELED
    };
}

function changeFilter(key, value) {
    return {
        type: actionTypes.CHANGE_FILTER,
        key: key,
        value: value
    };
}

function clearSynopsesFilter() {
    return {
        type: actionTypes.CLEAR_SYNOPSES_FILTER
    };
}

var actionCreators = {
    fetchSynopsesRequest: fetchSynopsesRequest,
    fetchSynopsesSucceeded: fetchSynopsesSucceeded,
    fetchSynopsesFailed: fetchSynopsesFailed,
    fetchSynopsisRequest: fetchSynopsisRequest,
    fetchSynopsisSucceeded: fetchSynopsisSucceeded,
    fetchSynopsisFailed: fetchSynopsisFailed,
    editSynopsisRequest: editSynopsisRequest,
    editSynopsisSucceeded: editSynopsisSucceeded,
    editSynopsisFailed: editSynopsisFailed,
    editSynopsisCanceled: editSynopsisCanceled,
    changeFilter: changeFilter,
    clearSynopsesFilter: clearSynopsesFilter
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/synopses.js
// module id = 269
// module chunks = 0